import { SoundResource } from '../model/resources';

export interface ItemWrapper<T> {
    file?: File;
    item?: T;
    error?: { message: string };
}

export const getPoller = (
    items: Array<ItemWrapper<SoundResource>>,
    getSkillSound: (soundId: string) => Promise<SoundResource>,
    update: (item: ItemWrapper<SoundResource>) => void,
) => {
    let isActive = true;
    const stop = () => {
        isActive = false;
    };

    (async () => {
        while (isActive) {
            const item = items.pop();
            if (!item) {
                stop();
                return;
            }

            try {
                const sound = await getSkillSound(item.item!.id);
                if (sound.isProcessed || sound.error) {
                    item.item = sound;

                    if (isActive) {
                        update(item);
                    }
                } else {
                    items.unshift(item);
                }
            } catch (e) {
                items.unshift(item);
                console.error(e);
            } finally {
                await delay(500);
            }
        }
    })().catch(console.error);

    return stop;
};

const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
